module.exports = __webpack_public_path__ + "img/South Georgia and the South Sandwich Islands.77923ab9.svg";